export default {"src":"/_next/static/image/public/images/flags/flag_27.84b9e14b0717097078e91f2f8e5bfd75.svg","height":16,"width":24};